import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { PostsList } from './PostsList';
import { posts } from '../services/posts';
import { fromSeoFriendlyUrl } from '../utils/urlHelpers';

export const CategoryView: FC = () => {
  const { categoryId } = useParams();
  
  const decodedCategory = fromSeoFriendlyUrl(categoryId);
  
  const filteredPosts = posts.filter(
    post => post.category === decodedCategory
  );
  
  return <PostsList posts={filteredPosts} />;
}; 